class Slider {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    let storageSwiper;
    function initSwiper() {
      if (storageSwiper) {
        storageSwiper.destroy(true, true);
        storageSwiper = null;
      }
    
      if (window.innerWidth <= 768) {
        storageSwiper = new Swiper('.c-swiper-storage', {
          speed: 1000,
          spaceBetween: 16,
          slidesPerView: 1.5,
          centeredSlides: true,
          loop: false,
          navigation: {
            prevEl: ".s-storage-prev",
            nextEl: ".s-storage-next"
          },
          on: {
            init: function () {
              updateSlideCount(this);
            },
            slideChange: function () {
              updateSlideCount(this);
            }
          }
        });

        function updateSlideCount(swiper) {
          const currentSlide = swiper.realIndex + 1;
          const totalSlides = swiper.slides.length;
          document.querySelector('.s-storage-num').textContent = `${currentSlide} / ${totalSlides}`;
        }

      }
    }
    
    initSwiper();
    window.addEventListener('resize', initSwiper);
  }
}
